export default __webpack_public_path__ + "static/media/hero-img.3bf80e8d.png";